// "use client";

// import { useEffect } from "react";

// export default function ClientBody({
//   children,
// }: {
//   children: React.ReactNode;
// }) {
//   // Remove any extension-added classes during hydration
//   useEffect(() => {
//     // This runs only on the client after hydration
//     document.body.className = "min-h-screen bg-white font-sans antialiased" ;
//   }, []);

//   return <>{children}</>;
// }
"use client";

import { useEffect, useMemo } from "react";
import { useFont } from "@/context/FontContext";
import { barlow, montserrat, mulish, poppins, roboto } from "@/fonts";
import { Toaster } from "sonner";

export default function ClientBody({ children }: { children: React.ReactNode }) {
  const { font } = useFont();

  const fontClass = useMemo(() => {
    switch (font) {
      case "Poppins":
        return poppins.className;
      case "Montserrat":
        return montserrat.className;
      case "Mulish":
        return mulish.className;
      case "Roboto":
        return roboto.className;
      case "Barlow":
      default:
        return barlow.className;
    }
  }, [font]);

  useEffect(() => {
    document.documentElement.className = fontClass;
    document.body.className = `antialiased min-h-screen bg-white ${fontClass}`;
  }, [fontClass]);

  return (
    <>
      {children}
      <Toaster richColors position="top-right" />
    </>
  );
}
